import * as React from "react";
import {createMarkup} from "../../helpers/helpers";

const TankOrigin = (props) => {
    const tankOriginTitle = gettext("Tank Origin");

    return (
        <section className="tank-origin">
            <div className="tank-page_slant-bar">
                <div className="tank-page_slant-bar_left"></div>
                <div className="tank-page_slant-bar_middle"></div>
                <div className="tank-page_slant-bar_right"></div>
            </div>
            <div className="tank-origin_content">
                <h3 className="tank-origin_title">{tankOriginTitle}</h3>
                <p className="tank-origin_description" dangerouslySetInnerHTML={createMarkup(props.description)}>
                </p>
            </div>
            <div className="tank-page_slant-bar">
                <div className="tank-page_slant-bar_left"></div>
                <div className="tank-page_slant-bar_middle"></div>
                <div className="tank-page_slant-bar_right"></div>
            </div>
        </section>
    )
};
export default TankOrigin;